import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../../../theme';

export const useBadgeStyles = createStyles(({ token }) => ({
  badge: {
    fontSize: token.fontSizeSM,
    padding: `${ThemeSpaces.SPACE_NORM0_5}px ${ThemeSpaces.SPACE_NORM}px`,
    backgroundColor: token.colorPrimary,
    display: 'inline-block',
    borderRadius: token.borderRadiusSM,
    color: token.colorWhite,
    marginRight: 6,
    lineHeight: 'normal',
  },
}));
